import { InputAdornment, TextField } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { noop } from "lodash";
import React, { PropsWithChildren, useMemo, useState } from "react";
import { t } from "ttag";
import { useStoreActions, useStoreState } from "../../models/RootStore";
import GroupSearchMenuItem from "./GroupSearchMenuItem";
import MenuItemIcon from "./MenuItemIcon";
import { useStyles } from "./UnitsMenu.style";

const containsText = (name: any, searchText: any) =>
  name?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

const ModbusUnitsMenu: React.FC<PropsWithChildren<any>> = (
  props: PropsWithChildren<any>
) => {
  const c = useStyles();
  const { handleClose } = props;
  const updateSelections = useStoreActions((a) => a.selections.updateSelections);
  const selections = useStoreState((s) => s.selections.selections);
  const modbusUnits = useStoreState((s) => s.selections.getUnitsBySelection("modbusUnits", ""));
  const [searchText, setSearchText] = useState<any>("");

  const displayedModbusUnits = useMemo(
    () => {
      const units = modbusUnits.filter(
        (option: any) => option?.id !== "all" && containsText(option?.name, searchText),
      );
      if (units.length) {
        units.unshift({
          id: "all",
          name: t`All Modbus Units`,
        });
      }
      return units;
    },
    [searchText, modbusUnits]
  );

  const handleSelect = (id: string, type: any) => {
    updateSelections({ type, data: id });
    handleClose();
  };

  return (
    <div className={c.view}>
      <div className={c.main}>
        <div className={c.menuWrapper}>
          <TextField
            classes={{ root: c.textField }}
            size="small"
            variant="outlined"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              className: c.input,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fill: "#aaa2aa" }} />
                </InputAdornment>
              )
            }}
            onChange={(e: any) => {
              setSearchText(e.target.value);
            }}
            onClick={(e: any) => e.stopPropagation()}
            onKeyDown={(e: any) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />

          {!!displayedModbusUnits.length && <GroupSearchMenuItem
            title={t`Modbus Units`}
            onClick={noop}
            numItems={displayedModbusUnits.length - 1}
            className={c.indoor}
            isOpen={true}
          >
            {displayedModbusUnits.map((unit: any) => (
              <MenuItemIcon
                key={unit.id}
                title={unit.name}
                onClick={(id: string) => handleSelect(id, "modbusUnit")}
                unit={unit.id}
                isSelected={selections.modbusUnitId === unit.id}
              />
            ))}
          </GroupSearchMenuItem>}
        </div>
      </div>
    </div>
  );
};

export default ModbusUnitsMenu;
